<!--
    Program: RequestStatus.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <div>
        <div id="contents" v-show="mode === MODE.LIST">
            <div class="contents_wrap">
                <h2 class="pg_title">Mobile SVC Request Status</h2>
                <!-- breadcrumbs -->
                <div class="bc_ico">
                    Home
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em>Engineer
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em>Mobile SVC
                    <em>
                        <span class="sr_only">&gt;</span>
                    </em>Mobile SVC Request Status
                </div>
                <!-- //breadcrumbs -->
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w49">
                                <li class="tit_150">Request Type</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        name="requestType"
                                        ref="selectRequestType"
                                        class="slt_white w100"
                                        v-model="selectedRequestType"
                                    >
                                        <option
                                            v-for="item in availableRequestTypeList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49" v-if="roleCd === 'S05'">
                                <li class="tit_150">Country</li>
                                <li data-input-type="select" class="w100-150">
                                    <select
                                        name="countries"
                                        ref="selectCountry"
                                        class="slt_white w100"
                                        v-model="selectedCountry"
                                    >
                                        <option
                                            v-for="item in availableCountryList"
                                            :key="item.CODE_ID"
                                            :value="item.CODE_ID"
                                        >{{item.CODE_NAME}}</option>
                                    </select>
                                </li>
                            </ul>
                            <ul class="w49">
                                <li class="tit_150">Request Date</li>
                                <li data-input-type="date">
                                    <fieldset class="ui_fieldset">
                                        <label class="date-wrap">
                                            <input
                                                id="fromDate"
                                                type="text"
                                                class="date_input w100"
                                                placeholder="From Date"
                                                maxlength="20"
                                                readonly
                                            />
                                            <a href="javascript:" class="in_btn" id="icoFromDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">Open Calendar</span>
                                            </a>
                                        </label>
                                        <div id="from-picker-container" />
                                        <em class="txt_space"></em>
                                        <label class="date-wrap">
                                            <input
                                                id="toDate"
                                                type="text"
                                                class="date_input w100"
                                                placeholder="To Date"
                                                maxlength="20"
                                                readonly
                                            />
                                            <a href="javascript:" class="in_btn" id="icoToDate">
                                                <i class="ico_date"></i>
                                                <span class="sr_only">Open Calendar</span>
                                            </a>
                                        </label>
                                        <div id="to-picker-container" style="margin-top: -1px;" />
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w49" v-if="roleCd === 'S05'">
                                <li class="tit_150">ID/Name/Email</li>
                                <li data-input-type="select" class="w100-150">
                                    <input
                                        type="text"
                                        class="date_input w100"
                                        maxlength="50"
                                        v-model="IDNameEmail"
                                        v-clearable
                                    />
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a
                                    href="javascript:"
                                    class="btn_srch"
                                    @click="onSearchBtnClick"
                                >Search</a>
                            </span>
                        </div>
                    </article>
                </div>
                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- Grid Count-->
                    <div class="grid_total">
                        Total Count
                        <em>{{ resultCount | numberFormat }}</em>
                    </div>
                    <!-- Grid -->
                    <div id="grid">
                        <toast-grid
                            gridId="gridContentHistory"
                            :key="gridKey"
                            :data="gridData"
                            :columns="gridColumns"
                            :options="gridOptions"
                            :pageOptions="gridPageOptions"
                            :theme="gridTheme"
                            :isTotalCount="false"
                            v-bind:click="onSelectGridCell"
                        />
                    </div>

                    <div class="paginate">
                        <sdl-pagination
                            :current-page="currentPage"
                            :total-rows="resultCount"
                            :per-page="perPage"
                            @change="onGoToPage"
                            align="center"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="mode === MODE.VIEW_REQ_ACCESS">
            <hhp-request-access-view :seqNo="seqNo" :onBackToList="() => {switchMode(MODE.LIST)}" />
        </div>
        <div v-else-if="mode === MODE.VIEW_REQ_OTHER">
            <hhp-request-other-view :seqNo="seqNo" :onBackToList="() => {switchMode(MODE.LIST)}" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import axios from 'axios';
import { SDLUtil, DateUtil } from '@/utils';

import qs from 'query-string';

import moment from 'moment';
import DatePicker from '~c/DatePicker';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import RequestStatusView from './RequestStatusView';
import RequestOtherView from './RequestOtherView';

const MODE = {
    LIST: 1,
    VIEW_REQ_ACCESS: 10,
    VIEW_REQ_OTHER: 20,
};

export default {
    name: '',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,

        'hhp-request-access-view': RequestStatusView,
        'hhp-request-other-view': RequestOtherView,
    },
    props: [],
    computed: {},
    data() {
        return {
            pageTitle: '',

            MODE, // shorthand for 'MODE: MODE,'

            mode: MODE.LIST,

            ...mapGetters({
                locale: 'getLocale',
            }),

            availableCountryList: [],
            selectedCountry: 'ALL',
            availableRequestTypeList: [],
            selectedRequestType: 'ALL',

            roleCd: '',

            IDNameEmail: '',

            searchParams: {
                reqType: 'ALL',
                Nation: 'ALL', // country
                searchToAddDt: '',
                searchFromAddDt: '',
                IDNameEmail: '',
            },


            rangePicker: null,

            startDatePicker: null,
            endDatePicker: null,

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            seqNo: 0,

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'No.',
                    name: 'RNUM',
                    width: 80,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Request Type',
                    name: 'REQ_TYPE',
                    align: 'left',
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Status',
                    name: 'STATUS',
                    width: 180,
                    align: 'center',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Request',
                    name: 'REQUEST',
                    width: 180,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: '1st Approval',
                    name: 'APPROVAL1',
                    width: 160,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: '2nd Approval',
                    name: 'APPROVAL2',
                    width: 160,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
                rowHeight: 'auto',
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        SDLUtil.showLoadingBar(true);
        // To Create CERT INFO Session on server
        SDLUtil.getRequest('/basis/certificate/CertMain.skp');

        this.initLoad()
            .then(res => {
                if (!this.validateSearchParams()) return;
                const params = this.prepSearchParams(1);
                this.search(params);
                SDLUtil.showLoadingBar(false);
            })
            .catch(err => {
                SDLUtil.showLoadingBar(false);
            });
    },
    mounted() {
        // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false }
        );
    },
    methods: {
        async initLoad() {
            return await this.fetchInitData()
                .then(data => {
                    // console.log('FetchInitData', data);
                    this.roleCd = data.roleCD;
                    this.setAvailableCountryList(data.countryList);
                    this.setAvailableRequestTypeList(data.reqTypeList);
                })
                .catch(err => {
                    // HhpCerts.handleUnauthorized(err)
                    //     .then(res => {
                    //         this.initLoad();
                    //         return res;
                    //     });
                });

        },

        setAvailableCountryList(list = []) {
            this.availableCountryList = list.map(item => {
                return {
                    CODE_NAME: item[0].replace(/"/g, ''),
                    CODE_ID: item[1].replace(/"/g, ''),
                };
            });
        },

        setAvailableRequestTypeList(list = []) {
            this.availableRequestTypeList = list.map(item => {
                return {
                    CODE_NAME: item[0].replace(/"/g, ''),
                    CODE_ID: item[1].replace(/"/g, ''),
                };
            });
        },

        fetchInitData() {
            const path = '/basis/anysvcmobile/request/Request.skp';
            return SDLUtil.getRequest(path)
            // return (
            //     axios
            //         // Loads data such as list of countries, etc...
            //         .get(`${SDLUtil.API_URL}/basis/anysvcmobile/request/Request.skp`)
            //         .then(res => {
            //             console.log('Mobile Request Status', res);
            //             return res.data;
            //         })
            // );
        },

        onSearchBtnClick() {
            if (!this.validateSearchParams()) return;
            const params = this.prepSearchParams(1);
            this.search(params);
        },
        validateSearchParams() {
            return true;
        },

        prepSearchParams(pageNo = 1, exclude = []) {
            const format = moment().toMomentFormatString('MM.dd.yyyy');

            const searchFromAddDt = this.rangePicker.getStartDate()
                ? moment(this.rangePicker.getStartDate()).formatWithJDF(format)
                : '';
            const searchToAddDt = this.rangePicker.getEndDate()
                ? moment(this.rangePicker.getEndDate()).formatWithJDF(format)
                : ''/*moment().formatWithJDF(format)*/;

            const params = {
                page: pageNo,
                reqType: this.selectedRequestType,
                Nation: this.selectedCountry,
                searchToAddDt,
                searchFromAddDt,
                IDNameEmail: this.IDNameEmail,
            };

            if (exclude.length > 0) {
                exclude.forEach(item => {
                    if (item in params) delete params[item];
                });
            }

            // console.log('search params', params);
            return params;
        },
        async search(params) {
            SDLUtil.showLoadingBar(true);
            await this.fetchSearchResult(params).then(res => {
                // console.log('RES', res);
                this.lastSearchParams = params;
                this.resultCount = res.data.count;

                let { rows } = res.data;
                // console.log('ROWS', rows);
                this.setGridData(rows);
                this.currentPage = params.page;
                return res;
            });
            SDLUtil.showLoadingBar(false);
        },
        fetchSearchResult(params) {
            const formData = qs.stringify(params);
            return axios
                .post(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestSearchAjax.skp`, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    // console.log('SEARCH RESULT', res);
                    return res;
                });
        },
        setGridData(rows) {
            if (!rows) return;
            this.gridData = rows.map(item => {
                if (typeof item.APP_TIME === 'undefined') item.APP_TIME = '...';
                if (typeof item.COMP_TIME === 'undefined') item.COMP_TIME = '...';
                item.RNUM = item.RNUM;
                item.REQUEST = `${item.REQ_USER}<br>[${item.REQ_TIME}]`;
                item.APPROVAL1 = `${item.APP_USER_ID}<br>[${item.APP_TIME}]`;
                item.APPROVAL2 = `${item.COMP_USER_ID}<br>[${item.COMP_TIME}]`;
                return item;
            });
            // this.gridData = rows;
            this.gridKey += 1;
        },

        onSelectGridCell(event, rowData) {
            // console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            // console.log('eventData', rowData[event.rowKey]);
            const row = rowData[event.rowKey];
            const seqNo = row.SEQ_NO;

            // let showFn = row.TYPE_CD === "001" ?
            //     this.showRequestAccessView : this.showRequestOtherView;
            // showFn(seqNo);
            row.TYPE_CD === '001' ? this.showRequestAccessView(seqNo) : this.showRequestOtherView(seqNo);
        },

        switchMode(mode) {
            this.mode = mode;
            window.scrollTo(0, 0);
        },
        showRequestAccessView(seqNo) {
            this.seqNo = seqNo.toString();
            this.switchMode(MODE.VIEW_REQ_ACCESS);
        },
        showRequestOtherView(seqNo) {
            this.seqNo = seqNo.toString();
            this.switchMode(MODE.VIEW_REQ_OTHER);
        },

        onGoToPage(pageNo) {
            this.lastSearchParams.page = pageNo;
            return this.search(this.lastSearchParams);
        },

        fetchRequestAccessViewData(seqNo) {
            const params = {
                seq_no: seqNo,
            };
            return axios.get(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestIssueView.skp`, { params });
        },
        fetchRequestOtherViewData(seqNo) {
            const params = {
                seq_no: seqNo,
            };
            return axios.get(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestOtherView.skp`, { params });
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/request/RequestStatus.vue